"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertSchedulingMode = exports.AlertNames = void 0;
var AlertNames;
(function (AlertNames) {
    AlertNames["PriceDropAlert"] = "Price Drop Alert";
    AlertNames["AvailabilityAlert"] = "Availability Alert";
})(AlertNames = exports.AlertNames || (exports.AlertNames = {}));
// TODO: Eventually we should probably support this at the step level, too.
var AlertSchedulingMode;
(function (AlertSchedulingMode) {
    /**
     * Follow traditional scheduling for automation events
     * (e.g. 10am email, 5:15pm text)
     */
    AlertSchedulingMode["Optimize"] = "optimize";
    /**
     * Immediately schedule an automation event within
     * business hours (M-Su 8am-6pm)
     */
    AlertSchedulingMode["Immediate"] = "immediate";
})(AlertSchedulingMode = exports.AlertSchedulingMode || (exports.AlertSchedulingMode = {}));
